var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { Promise } from 'rsvp';
import { isEmpty } from '@ember/utils';
import moment from 'moment';
import { ajax, jsonPost } from '@square/dashboard-utilities/utils/xhr';
import { apiHost } from '@square/environment-utils/api-urls';
const createIdentityTokenFromSessionUrl = '/services/squareup.multipass.external.MultipassExternalService/CreateIdentityTokenFromSession';
let EcomPasetoAjax = (_class = class EcomPasetoAjax extends Service {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_authToken", null);
    _defineProperty(this, "_retries", 0);
    _defineProperty(this, "_resolve", null);
    _defineProperty(this, "_reject", null);
    _initializerDefineProperty(this, "userInfo", _descriptor, this);
  }
  _auth() {
    return new Promise((resolve, reject) => {
      if (isEmpty(this._authToken)) {
        jsonPost(`//${apiHost(location.host)}${createIdentityTokenFromSessionUrl}`, {}).then(response => {
          this._authToken = response.id_token;
          resolve('success');
        }).catch(() => {
          reject(new Error('unauthorized'));
        });
      } else {
        resolve('success');
      }
    });
  }
  _authRetry() {
    this._authToken = null;
    return this._auth();
  }
  _request(endpoint, type, data = {}) {
    return new Promise((resolve, reject) => {
      ajax(endpoint, {
        type,
        data,
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        headers: {
          Accept: 'application/json',
          'Ecom-Merchant': this.userInfo.merchantToken,
          'Ecom-Locale': this.userInfo.countryCode,
          Authorization: this._authToken,
          'Ecom-Version': moment().add(1, 'days').format('YYYY-MM-DD')
        }
      }).then(resp => {
        resolve(resp);
      }).catch(resp => {
        reject(resp);
      });
    });
  }
  async ajax(endpoint, type, data = {}, authRetry = true) {
    let dataFormatted = data;
    if (type !== 'GET') {
      dataFormatted = JSON.stringify(dataFormatted);
    }
    let request = null;
    try {
      await this._auth();
    } catch (e) {
      return e;
    }
    try {
      request = await this._request(endpoint, type, dataFormatted);
    } catch (e) {
      if (!authRetry) {
        throw e;
      }
      try {
        await this._authRetry();
      } catch (e) {
        return e;
      }
      try {
        request = await this._request(endpoint, type, dataFormatted);
      } catch (e) {
        return e;
      }
    }
    return request;
  }
  async getAuthToken(forceRefresh = false) {
    if (this._authToken !== null && forceRefresh === false) {
      return this._authToken;
    } else {
      await this._authRetry();
      return this._authToken;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { EcomPasetoAjax as default };